import React, { useState } from "react";

import user1 from "../../assets/testimonial-images/bhalen-singh.jpeg";
import user2 from "../../assets/testimonial-images/SHRINATH H.G.jpeg";
import user3 from "../../assets/testimonial-images/dev-g-roy.jpeg";
import user4 from "../../assets/testimonial-images/suman-shrivastav.jpeg";
import user5 from "../../assets/testimonial-images/arvind-shrivastav.jpeg";
import user6 from "../../assets/testimonial-images/abha-sharama.jpeg";
import user7 from "../../assets/testimonial-images/bhagwati-devi.jpeg";
import user8 from "../../assets/testimonial-images/ankit.jpeg";
import user9 from "../../assets/testimonial-images/rohit.jpeg";
import user10 from "../../assets/testimonial-images/hari-prashad-sharma.jpeg";
import user11 from "../../assets/testimonial-images/Ranvijay.jpeg";
import user12 from "../../assets/testimonial-images/Rajeeb.jpeg";

const reviews = [
  // Madhumeh Reviews (4 reviews)
  {
    name: "Bhalen Singh",
    title: "Verified Customer",
    image: user1,
    heading: "Madhumeh se kaafi fayda hua",
    text: "मैं 3 महीने से Madhumeh Powder ले रहा हूं। Sugar level काफी control में है। Natural aur safe hai.",
    rating: 4.8,
    product: "Madhumeh Sugar Powder"
  },
  {
    name: "SHRINATH H.G",
    title: "Verified Customer",
    image: user2,
    heading: "Best for diabetes management",
    text: "My mother has been using Madhumeh for 2 months. Her blood sugar levels are stable now. Highly recommend!",
    rating: 4.5,
    product: "Madhumeh Sugar Powder"
  },
  {
    name: "Suman Shrivastav",
    title: "Verified Customer",
    image: user4,
    heading: "बहुत अच्छा प्रोडक्ट",
    text: "Madhumeh Powder लेने के बाद मेरी थकान कम हो गई है। Sugar bhi control me hai. Worth buying!",
    rating: 4.6,
    product: "Madhumeh Sugar Powder"
  },
  {
    name: "Hari Prashad Sharma",
    title: "Verified Customer",
    image: user10,
    heading: "Effective results with Madhumeh",
    text: "मुझे diabetes है और Madhumeh Powder से काफी फर्क पड़ा। Energy level improve हुआ।",
    rating: 4.7,
    product: "Madhumeh Sugar Powder"
  },

  // Pachan Care Reviews (2 reviews)
  {
    name: "Dev Roy",
    title: "Verified Customer",
    image: user3,
    heading: "पाचन में सुधार हुआ",
    text: "Pachan Care Powder लेने से acidity की problem खत्म हो गई। Digestion bahut achha hai ab.",
    rating: 4.9,
    product: "Pachan Care Powder"
  },
  {
    name: "Ankit",
    title: "Verified Customer",
    image: user8,
    heading: "Gas और acidity से राहत",
    text: "मुझे gastric problem थी। Pachan Care ने बहुत help की। Natural ingredients hai.",
    rating: 4.4,
    product: "Pachan Care Powder"
  },

  // Liver Care Reviews (2 reviews)
  {
    name: "Arvind Shrivastav",
    title: "Verified Customer",
    image: user5,
    heading: "Liver health improved",
    text: "Liver Care Tablet लेने के बाद मुझे बहुत अच्छा लगा। Detox aur energy boost mila.",
    rating: 4.7,
    product: "Liver Care Tablet"
  },
  {
    name: "Bhagwati Devi",
    title: "Verified Customer",
    image: user7,
    heading: "लिवर के लिए बढ़िया",
    text: "Quality achhi hai. Liver problems me help milti hai. No side effects.",
    rating: 4.6,
    product: "Liver Care Tablet"
  },

  // Diacare Reviews (2 reviews)
  {
    name: "Abha Sharma",
    title: "Verified Customer",
    image: user6,
    heading: "Good for sugar control",
    text: "Diacare Powder se sugar level stable रहता है। मैं satisfied हूं।",
    rating: 4.8,
    product: "Diacare Powder"
  },
  {
    name: "Rohit",
    title: "Verified Customer",
    image: user9,
    heading: "डायबिटीज में मददगार",
    text: "Diacare Powder daily use कर रहा हूं। Results achhe hai. Lifestyle me easily fit ho gaya.",
    rating: 4.5,
    product: "Diacare Powder"
  },

  // Diacorex Reviews (2 reviews)
  {
    name: "Ranvijay",
    title: "Verified Customer",
    image: user11,
    heading: "शानदार results मिले",
    text: "Diacorex Tablet से insulin support achha mila. Sugar levels neeche aa gaye.",
    rating: 4.8,
    product: "Diacorex Tablet"
  },
  {
    name: "Rajeeb",
    title: "Verified Customer",
    image: user12,
    heading: "Natural and safe tablet",
    text: "Diacorex लेने से कोई problem नहीं हुई। Natural hai aur effective bhi. Recommended!",
    rating: 4.3,
    product: "Diacorex Tablet"
  },
];

const VISIBLE = 4;

// Star rating component
const StarRating = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.3 && rating % 1 < 0.8;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="stars">
      <span className="rating-number">{rating}</span>
      {[...Array(fullStars)].map((_, i) => (
        <span key={`full-${i}`} className="star full">★</span>
      ))}
      {hasHalfStar && <span className="star half">★</span>}
      {[...Array(emptyStars)].map((_, i) => (
        <span key={`empty-${i}`} className="star empty">☆</span>
      ))}
    </div>
  );
};

const TestimonialSlider = () => {
  const [start, setStart] = useState(0);

  const next = () => {
    if (start + VISIBLE < reviews.length) {
      setStart(start + VISIBLE);
    }
  };

  const prev = () => {
    if (start - VISIBLE >= 0) {
      setStart(start - VISIBLE);
    }
  };

  return (
    <section className="testimonial-section">
      <h2 className="testimonial-header">Trusted Reviews</h2>
      <p className="testimonial-para">
        Our patients across the globe share genuine experiences of improved
        health, better lifestyle, and trusted results through our natural
        medicines
      </p>
      <div className="slider-header">
        <button onClick={prev} className="arrow" disabled={start === 0}>
          ‹
        </button>
        <button onClick={next} className="arrow" disabled={start + VISIBLE >= reviews.length}>
          ›
        </button>
      </div>

      <div className="testimonial-grid">
        {reviews.slice(start, start + VISIBLE).map((item, i) => (
          <div className="testimonial-card" key={i}>
            <div className="avatar">
              <img src={item.image} alt={item.name} />
            </div>

            <StarRating rating={item.rating} />
            <h4>{item.heading}</h4>
            <p>{item.text}</p>
            <div className="product-tag">{item.product}</div>

            <h5>{item.name}</h5>
            <span>{item.title}</span>

            <div className="quotes">" "</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialSlider;
